module.exports = __webpack_public_path__ + "img/avi.ec2153db.svg";